import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Provider } from "react-redux";
import { persistor, store } from "../src/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import 'leaflet/dist/leaflet.css';
import "./i18n";
import '../src/assets/css/Font.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import GameSocketListener from './pages/gamelist/GameSocketListener';
import FindPlayerSocket from './pages/findPlayer/FindPlayerSocket';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <FindPlayerSocket>
        <GameSocketListener> */}
          <App />
        {/* </GameSocketListener>
      </FindPlayerSocket> */}
    </PersistGate>
  </Provider>
);
reportWebVitals();
